module.exports = __webpack_public_path__ + "static/media/Fox-Searchlight-Pictures.c5fc895b.png";